import { useEffect, useState } from "react";
import { CloseButton } from "../SvgComponents";
import { subscribeEmailList } from "../../API";
import messages from "../../constants/messages";
import Spinner from "../Spinner/Spinner"
import Swal from 'sweetalert2'
import { useNavigate } from "react-router-dom";

function isValidEmail(email) {
    var pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return pattern.test(email);
}

export default function EmailSubscriptionPopup() {
    const [email, setEmail] = useState('');
    const [isClosed, setIsClosed] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    useEffect(()=>{
        const hasShownSubscriptionPopup = localStorage.getItem('hasShownSubscriptionPopup')
        if (!hasShownSubscriptionPopup) setIsClosed(false)
    }, []);
    function closeButtonClickHandler() {
        localStorage.setItem('hasShownSubscriptionPopup', true)
        setIsClosed(true);
    }
    function inputOnChangeHandler(e) {
        setEmail(e.target.value)
    }
    async function subscribeButtonClickHandler() {
        if(!isValidEmail(email)) {
            Swal.fire({
                title: "Please provide valid Email Id",
                icon: "info"
            })
            return;
        };
        setIsLoading(true);
        const resMessage = await subscribeEmailList(email);
        if (resMessage === messages.ADDED || resMessage === messages.ALREADY_EXISTED) {
            localStorage.setItem('hasShownSubscriptionPopup', true);
            setIsClosed(true);
            navigate('/site/subscription/success');
        } else if (resMessage === messages.INTERNAL_SERVER_ERROR || resMessage === messages.STATUS_UNKNOWN) {
            // Set cookie with some timeout and after that timout display pop-up again
            Swal.fire({
                icon: "error",
                text: "Something went wrong!",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true
            });
        };
        setIsLoading(false);
    }
    if (isClosed) return null;
    return <div style={{
        position: 'fixed',
        background: '#80808099',
        zIndex: '1000',
        height: '100vh',
        width: '100vw',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }}>
        <div style={{
            background: '#e2e1e1',
            height: '400px',
            width: '800px',
            borderRadius: '1rem',
            padding: '1rem 1rem',
            border: '3px solid green'
        }}>
            <div style={{display: 'flex'}}>
                <span onClick={closeButtonClickHandler} style={{height: '2rem', width: '2rem', color: 'green', marginLeft: 'auto', cursor: 'pointer'}}>
                    <CloseButton/>
                </span>
            </div>
            <div style={{padding: '2rem 2rem'}}>
                <div style={{display: 'flex'}}>
                    <h1>Plant Your First Tree For Free</h1>
                </div>
                <p>
                    <strong style={{fontStyle: 'italic', }}>Subscribe to learn more about our global movement, how we plant Super Trees, build communities, restore whole ecosystems, and FIGHT CLIMATE CHANGE</strong>
                </p>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <input value={email} onChange={inputOnChangeHandler} placeholder="Enter Email Address" />
                    
                    {isLoading ? <div className="subscribe-button" style={{height: "3rem"}}>
                        <Spinner color="green" />
                    </div> : <span onClick={subscribeButtonClickHandler} className="subscribe-button" >Subscribe</span>}
                </div>
            </div>
        </div>
    </div>
}